module.exports = (__webpack_require__(0))(8);


//////////////////
// WEBPACK FOOTER
// delegated ./src/constants.js from dll-reference girder_lib
// module id = 49
// module chunks = 0